import { render, staticRenderFns } from "./Flexible.vue?vue&type=template&id=44cec5fa&scoped=true"
import script from "./Flexible.vue?vue&type=script&lang=js"
export * from "./Flexible.vue?vue&type=script&lang=js"
import style0 from "./Flexible.vue?vue&type=style&index=0&id=44cec5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cec5fa",
  null
  
)

export default component.exports